export default __webpack_public_path__ + "b02e6d2bb7dac4f23c7b1959c42579d9.png";